import { YOUTUBE_CATEGORIES } from '../../constants/platformCompliance';

const YouTubeSettingsPanel = ({ settings, onChange, capabilities }) => {
  const categories = capabilities?.availableCategories?.length
    ? capabilities.availableCategories
    : YOUTUBE_CATEGORIES;

  return (
    <div className="space-y-4">
      {/* Privacy */}
      <div>
        <label className="label">Privacy</label>
        <select
          className="input w-full"
          value={settings.privacyStatus || 'public'}
          onChange={e => onChange({ ...settings, privacyStatus: e.target.value })}
        >
          <option value="public">Public</option>
          <option value="unlisted">Unlisted</option>
          <option value="private">Private</option>
        </select>
      </div>

      {/* Category */}
      <div>
        <label className="label">Category</label>
        <select
          className="input w-full"
          value={settings.categoryId || '22'}
          onChange={e => onChange({ ...settings, categoryId: e.target.value })}
        >
          {categories.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>

      {/* Made for Kids */}
      <div className="flex items-center gap-3">
        <input
          type="checkbox"
          id="yt-madeForKids"
          className="h-4 w-4 rounded border-gray-300"
          checked={settings.madeForKids || false}
          onChange={e => onChange({ ...settings, madeForKids: e.target.checked })}
        />
        <label htmlFor="yt-madeForKids" className="text-sm text-gray-700 dark:text-gray-300">
          Made for Kids (COPPA compliance)
        </label>
      </div>

      {/* Tags */}
      <div>
        <label className="label">Tags (comma-separated)</label>
        <input
          type="text"
          className="input w-full"
          placeholder="travel, vlog, adventure"
          value={(settings.tags || []).join(', ')}
          onChange={e => onChange({
            ...settings,
            tags: e.target.value.split(',').map(t => t.trim()).filter(Boolean),
          })}
        />
        {settings.tags?.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-2">
            {settings.tags.map((tag, i) => (
              <span key={i} className="px-2 py-0.5 text-xs rounded-full bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default YouTubeSettingsPanel;
